import React from 'react'
import './burger.scss';


export const Burger = ({ isActive, onClick }) => {
    return (
        <div 
            className={`burger-mobile ${isActive ? 'burger-mobile-active' : ''}`} 
            onClick={onClick}
        >
            <div className="burger-line"></div>
            <div className="burger-line"></div>
            <div className="burger-line"></div>
        </div>
    )
}
